module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-add-parking-lot"
  }, [_c('div', {
    staticClass: "row columns callout"
  }, [_c('h6', [_vm._v("Add new Parking Lot")]), _c('h3', [_vm._v("Selected Parking Group: " + _vm._s(_vm.item.name))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _c('label', [_vm._v("Available slots"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.availableSlots),
      expression: "availableSlots"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.availableSlots)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.availableSlots = $event.target.value
      }
    }
  })]), _c('label', [_vm._v("Allowed Zone"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allowed_zone_id),
      expression: "allowed_zone_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.allowed_zone_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Not Selected")]), _vm._l((_vm.zones), function(zone) {
    return _c('option', {
      domProps: {
        "value": zone.id
      }
    }, [_vm._v(_vm._s(zone.name))])
  })], 2)]), _c('label', [_vm._v("Undesirable Zone"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undesiderable_zone_id),
      expression: "undesiderable_zone_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.undesiderable_zone_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Not Selected")]), _vm._l((_vm.zones), function(zone) {
    return _c('option', {
      domProps: {
        "value": zone.id
      }
    }, [_vm._v(_vm._s(zone.name))])
  })], 2)]), _c('label', [_vm._v("Forbidden zone"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forbidden_zone_id),
      expression: "forbidden_zone_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.forbidden_zone_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Not Selected")]), _vm._l((_vm.zones), function(zone) {
    return _c('option', {
      domProps: {
        "value": zone.id
      }
    }, [_vm._v(_vm._s(zone.name))])
  })], 2)])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Description")]), _c('Editor', {
    attrs: {
      "value": _vm.description
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _c('label', [_vm._v("Picture"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picture),
      expression: "picture"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.picture)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.picture = $event.target.value
      }
    }
  })]), _c('kepler-file-upload', {
    attrs: {
      "selected-prefix": "parking-lot",
      "selected-visibility": "public"
    },
    on: {
      "sel": _vm.handleFileSelector
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Latitude"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.latitude),
      expression: "latitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.latitude = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Longitude"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.longitude),
      expression: "longitude"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.longitude = $event.target.value
      }
    }
  })])])]), _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.openMap = !_vm.openMap
      }
    }
  }, [_vm._v("Toggle Map")]), (_vm.openMap) ? _c('div', {
    staticClass: "row columns"
  }, [_c('label', [_vm._v("Click on the map for select the parking lot position")]), _c('div', {
    staticClass: "map-wrapper"
  }, [_c('GoogleMapContainer', [_c('GoogleMap', {
    attrs: {
      "apiKey": _vm.mapKey,
      "center": _vm.mapCenter,
      "searchBar": true,
      "mapTypeId": 'roadmap',
      "mapTypeControl": true,
      "listenForClick": true
    },
    on: {
      "mapClicked": _vm.updateMarker,
      "placesChanged": _vm.hideMarker
    }
  }, [(_vm.markerPosition) ? _c('GoogleMapMarker', {
    attrs: {
      "position": _vm.mapCenter,
      "title": "",
      "label": ""
    }
  }) : _vm._e(), (_vm.undesiderable_zone_id) ? _c('div', {
    staticClass: "polygons"
  }, _vm._l((_vm.zones[_vm.undesiderable_zone_id].poly), function(p) {
    return _c('GoogleMapPolygon', {
      attrs: {
        "positions": p,
        "color": "yellow",
        "fillColor": "yellow"
      }
    })
  }), 1) : _vm._e(), (_vm.forbidden_zone_id) ? _c('div', {
    staticClass: "polygons"
  }, _vm._l((_vm.zones[_vm.forbidden_zone_id].poly), function(p) {
    return _c('GoogleMapPolygon', {
      attrs: {
        "positions": p,
        "color": "red",
        "fillColor": "red"
      }
    })
  }), 1) : _vm._e(), (_vm.allowed_zone_id) ? _c('div', {
    staticClass: "polygons"
  }, _vm._l((_vm.zones[_vm.allowed_zone_id].poly), function(p) {
    return _c('GoogleMapPolygon', {
      attrs: {
        "positions": p,
        "color": "green",
        "fillColor": "green"
      }
    })
  }), 1) : _vm._e()], 1)], 1)], 1), _c('p', [_vm._v(_vm._s(_vm.latitude) + " " + _vm._s(_vm.longitude))])]) : _vm._e(), _c('div', {
    staticClass: "row column"
  }, [_c('button', {
    staticClass: "button",
    class: {
      disabled: !_vm.description || !_vm.name || !_vm.latitude || !_vm.longitude
    },
    on: {
      "click": _vm.addParkingLot
    }
  }, [_vm._v("Add")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-89e8341e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CreateParkingLot.vue
// module id = 2633
// module chunks = 1